"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationAddress = void 0;
const react_1 = __importDefault(require("react"));
const intl_1 = require("@kyruus/intl");
const utils_1 = require("./utils");
const messages_1 = __importDefault(require("../../lib/messages"));
const styles_1 = require("./styles");
const LocationAddress = ({ location }) => {
    const { city, street1, street2, suite, zip, state } = location;
    const streetAddress = (react_1.default.createElement("span", { itemProp: "streetAddress" }, [street1, street2, suite].filter(Boolean).join(', ')));
    const addressLocality = react_1.default.createElement("span", { itemProp: "addressLocality" }, city);
    const addressRegion = react_1.default.createElement("span", { itemProp: "addressRegion" }, state);
    const postalCode = react_1.default.createElement("span", { itemProp: "postalCode" }, zip);
    return (react_1.default.createElement(styles_1.LocationAddressRow, null,
        streetAddress,
        ", ",
        addressLocality,
        ", ",
        addressRegion,
        " ",
        postalCode));
};
exports.LocationAddress = LocationAddress;
const LocationAddressWithDirectionLink = ({ config, location }) => {
    var _a;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("li", null,
            react_1.default.createElement(exports.LocationAddress, { location: location })),
        /**
          maps_config.google_routes defaults to true
          only if it is set to false do we want to suppress google routing
        */
        ((_a = config.maps_config) === null || _a === void 0 ? void 0 : _a.google_routes) !== false ? (react_1.default.createElement("li", null,
            react_1.default.createElement(styles_1.LocationAddressRow, null,
                react_1.default.createElement(styles_1.LocationInfoItem, { noPrint: true },
                    react_1.default.createElement("a", { "data-testid": "GetDirectionsLink", href: (0, utils_1.getGoogleMapLink)(location), target: "_blank", rel: "noopener noreferrer" },
                        react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.getDirections))))))) : null));
};
exports.default = LocationAddressWithDirectionLink;
//# sourceMappingURL=location-address.js.map